import { actionTypes } from '../../constants';

export const initialState = {
  loading: false,
  error: false,
  content: {}
};

const config = (state = {}, action) => {
  switch (action.type) {
    case actionTypes.FETCH_CONFIG_SUCCESS:
      return { ...state, configValues: action.data };
    case actionTypes.SET_QUERY_PARAMS:
      return { ...state, ...action.params };
    case actionTypes.FETCH_USER_BANKID_SUCCESS:
      return {
        ...state,
        bankId: action.data.bank_id
      };
    case actionTypes.FETCH_CONTENT_SUCCESS:
      return {
        ...state,
        content: action.payload
      };
    case actionTypes.TRANSFER_SUCCESS:
      return {
        ...state,
        transferRequested: true,
        transferResponse: action.data
      };
    case actionTypes.CAPTURE_EVIDENCE:
      return {
        ...state,
        evidenceInitiated: true
      };
    case actionTypes.CAPTURE_EVIDENCE_SUCCESS:
      return {
        ...state,
        evidenceSuccess: true,
        evidenceInitiated: false,
        transferResponse: ''
      };
    default:
      return state;
  }
};

export default config;
